import { connect } from 'react-redux'
import HeaderFilterRoleSelect from 'components/HeaderFilterRoleSelect'

const mapStateToProps = (state: any) => {
  return {
    filterRoleName: state.filterRoleName,
  }
}

export default connect(mapStateToProps)(HeaderFilterRoleSelect)
